{
  "caption": "Diez fases por diez fases. Las filas son la fase de la pregunta; las columnas, la fase de la opción elegida.",
  "rows": {
    "pluto": "Espíritu",
    "neptune": "Gestión",
    "uranus": "Liderazgo",
    "saturn": "Requisitos",
    "sun": "Conceptualización",
    "moon": "Valoración",
    "mars": "Desarrollo",
    "mercury": "Imagen",
    "jupiter": "Organización",
    "venus": "Cierre"
  },
  "cols": {
    "pluto": "Cultura",
    "neptune": "Gestión",
    "uranus": "Liderazgo",
    "saturn": "Ciclo",
    "sun": "Proyección",
    "moon": "Reflexión",
    "mars": "Desarrollo",
    "mercury": "Diseño",
    "jupiter": "Operaciones",
    "venus": "Resultados"
  },
  "stats": {
    "total": "Σ",
    "totalLabel": "Total",
    "sd": "DE",
    "sdLabel": "Desviación estándar",
    "kurtosis": "K",
    "kurtosisLabel": "Curtosis en exceso",
    "undefined": "—",
    "grid": "Cuadrícula completa",
    "gridSummary": "n {{n}} · Σ {{total}} · DE {{sd}} · K {{kurtosis}}"
  }
}
